module.exports = __webpack_public_path__ + "static/trademark_hymots-9aa233886a591509c822d384bf2006dc.png";